import { useMemo } from 'react';

import { ProductColor } from '@ravago/shared/page-data/models/elements';

import { UNKNOWN_COLOR_ID, UNKNOWN_PRODUCER_COLOR_CODE } from '../constants';

interface Props {
   colors: ProductColor[] | undefined;
   colorId: number | undefined;
   colorName: string | undefined;
   producerColorCode: string | undefined;
}

export const useRequestForQuotationColor = ({ colors, colorId, colorName, producerColorCode }: Props) =>
   useMemo(() => {
      if (!colors) return undefined;

      if (colorName?.toLowerCase() === UNKNOWN_PRODUCER_COLOR_CODE) {
         return {
            id: UNKNOWN_COLOR_ID,
            colorName: UNKNOWN_PRODUCER_COLOR_CODE,
            producerColorCode: producerColorCode === UNKNOWN_PRODUCER_COLOR_CODE ? producerColorCode : undefined
         };
      }

      const selectedColorDetails =
         (colorId ? colors.find((c) => c.id === colorId) : undefined) ??
         (colorName ? colors.find((c) => c.name.toUpperCase() === colorName.toUpperCase()) : undefined);

      if (!selectedColorDetails) {
         if (colorId || colorName) {
            return {
               id: colorId,
               colorName: colorName ?? '',
               producerColorCode: producerColorCode
            };
         }
         const defaultColor = colors.find((c) => c.defaultColor);
         if (!defaultColor) return undefined;
         return {
            id: defaultColor.id,
            colorName: defaultColor.name,
            producerColorCode: undefined
         };
      }

      const selectedColorProducerColorCode = producerColorCode
         ? selectedColorDetails.producerColorCodes.find((cc) => cc.colorCode === producerColorCode)?.colorCode
         : undefined;

      return {
         id: selectedColorDetails.id,
         colorName: selectedColorDetails.name,
         producerColorCode: selectedColorProducerColorCode
      };
   }, [colors, colorId, colorName, producerColorCode]);
